/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { InconsistenciesResolvedPaginatedResponse } from '../models/inconsistencies-resolved-paginated-response';
import { InconsistenciesUnresolvedPaginatedResponse } from '../models/inconsistencies-unresolved-paginated-response';
import { LacEventsPaginatedResponse } from '../models/lac-events-paginated-response';
import { postFeV1LacEventsCash$Json } from '../fn/lac-events/post-fe-v-1-lac-events-cash-json';
import { PostFeV1LacEventsCash$Json$Params } from '../fn/lac-events/post-fe-v-1-lac-events-cash-json';
import { postFeV1LacEventsCash$Plain } from '../fn/lac-events/post-fe-v-1-lac-events-cash-plain';
import { PostFeV1LacEventsCash$Plain$Params } from '../fn/lac-events/post-fe-v-1-lac-events-cash-plain';
import { postFeV1LacEventsExportCash$Json } from '../fn/lac-events/post-fe-v-1-lac-events-export-cash-json';
import { PostFeV1LacEventsExportCash$Json$Params } from '../fn/lac-events/post-fe-v-1-lac-events-export-cash-json';
import { postFeV1LacEventsExportCash$Plain } from '../fn/lac-events/post-fe-v-1-lac-events-export-cash-plain';
import { PostFeV1LacEventsExportCash$Plain$Params } from '../fn/lac-events/post-fe-v-1-lac-events-export-cash-plain';
import { postFeV1LacEventsInconsistenciesResolved$Json } from '../fn/lac-events/post-fe-v-1-lac-events-inconsistencies-resolved-json';
import { PostFeV1LacEventsInconsistenciesResolved$Json$Params } from '../fn/lac-events/post-fe-v-1-lac-events-inconsistencies-resolved-json';
import { postFeV1LacEventsInconsistenciesResolved$Plain } from '../fn/lac-events/post-fe-v-1-lac-events-inconsistencies-resolved-plain';
import { PostFeV1LacEventsInconsistenciesResolved$Plain$Params } from '../fn/lac-events/post-fe-v-1-lac-events-inconsistencies-resolved-plain';
import { postFeV1LacEventsInconsistenciesResolvedExport$Json } from '../fn/lac-events/post-fe-v-1-lac-events-inconsistencies-resolved-export-json';
import { PostFeV1LacEventsInconsistenciesResolvedExport$Json$Params } from '../fn/lac-events/post-fe-v-1-lac-events-inconsistencies-resolved-export-json';
import { postFeV1LacEventsInconsistenciesResolvedExport$Plain } from '../fn/lac-events/post-fe-v-1-lac-events-inconsistencies-resolved-export-plain';
import { PostFeV1LacEventsInconsistenciesResolvedExport$Plain$Params } from '../fn/lac-events/post-fe-v-1-lac-events-inconsistencies-resolved-export-plain';
import { postFeV1LacEventsInconsistenciesUnresolved$Json } from '../fn/lac-events/post-fe-v-1-lac-events-inconsistencies-unresolved-json';
import { PostFeV1LacEventsInconsistenciesUnresolved$Json$Params } from '../fn/lac-events/post-fe-v-1-lac-events-inconsistencies-unresolved-json';
import { postFeV1LacEventsInconsistenciesUnresolved$Plain } from '../fn/lac-events/post-fe-v-1-lac-events-inconsistencies-unresolved-plain';
import { PostFeV1LacEventsInconsistenciesUnresolved$Plain$Params } from '../fn/lac-events/post-fe-v-1-lac-events-inconsistencies-unresolved-plain';
import { postFeV1LacEventsInconsistenciesUnresolvedExport$Json } from '../fn/lac-events/post-fe-v-1-lac-events-inconsistencies-unresolved-export-json';
import { PostFeV1LacEventsInconsistenciesUnresolvedExport$Json$Params } from '../fn/lac-events/post-fe-v-1-lac-events-inconsistencies-unresolved-export-json';
import { postFeV1LacEventsInconsistenciesUnresolvedExport$Plain } from '../fn/lac-events/post-fe-v-1-lac-events-inconsistencies-unresolved-export-plain';
import { PostFeV1LacEventsInconsistenciesUnresolvedExport$Plain$Params } from '../fn/lac-events/post-fe-v-1-lac-events-inconsistencies-unresolved-export-plain';

@Injectable({ providedIn: 'root' })
export class LacEventsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `postFeV1LacEventsCash()` */
  static readonly PostFeV1LacEventsCashPath = '/v1/lac-events/cash';

  /**
   * Search LAC events with filters.
   *
   * Search LAC events with filters.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postFeV1LacEventsCash$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postFeV1LacEventsCash$Plain$Response(params?: PostFeV1LacEventsCash$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<LacEventsPaginatedResponse>> {
    return postFeV1LacEventsCash$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Search LAC events with filters.
   *
   * Search LAC events with filters.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postFeV1LacEventsCash$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postFeV1LacEventsCash$Plain(params?: PostFeV1LacEventsCash$Plain$Params, context?: HttpContext): Observable<LacEventsPaginatedResponse> {
    return this.postFeV1LacEventsCash$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<LacEventsPaginatedResponse>): LacEventsPaginatedResponse => r.body)
    );
  }

  /**
   * Search LAC events with filters.
   *
   * Search LAC events with filters.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postFeV1LacEventsCash$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postFeV1LacEventsCash$Json$Response(params?: PostFeV1LacEventsCash$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<LacEventsPaginatedResponse>> {
    return postFeV1LacEventsCash$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Search LAC events with filters.
   *
   * Search LAC events with filters.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postFeV1LacEventsCash$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postFeV1LacEventsCash$Json(params?: PostFeV1LacEventsCash$Json$Params, context?: HttpContext): Observable<LacEventsPaginatedResponse> {
    return this.postFeV1LacEventsCash$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<LacEventsPaginatedResponse>): LacEventsPaginatedResponse => r.body)
    );
  }

  /** Path part for operation `postFeV1LacEventsExportCash()` */
  static readonly PostFeV1LacEventsExportCashPath = '/v1/lac-events/cash/export';

  /**
   * Export LAC events to Excel with applied filters.
   *
   * Export LAC events to Excel with applied filters.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postFeV1LacEventsExportCash$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postFeV1LacEventsExportCash$Plain$Response(params?: PostFeV1LacEventsExportCash$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return postFeV1LacEventsExportCash$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Export LAC events to Excel with applied filters.
   *
   * Export LAC events to Excel with applied filters.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postFeV1LacEventsExportCash$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postFeV1LacEventsExportCash$Plain(params?: PostFeV1LacEventsExportCash$Plain$Params, context?: HttpContext): Observable<Blob> {
    return this.postFeV1LacEventsExportCash$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /**
   * Export LAC events to Excel with applied filters.
   *
   * Export LAC events to Excel with applied filters.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postFeV1LacEventsExportCash$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postFeV1LacEventsExportCash$Json$Response(params?: PostFeV1LacEventsExportCash$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return postFeV1LacEventsExportCash$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Export LAC events to Excel with applied filters.
   *
   * Export LAC events to Excel with applied filters.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postFeV1LacEventsExportCash$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postFeV1LacEventsExportCash$Json(params?: PostFeV1LacEventsExportCash$Json$Params, context?: HttpContext): Observable<Blob> {
    return this.postFeV1LacEventsExportCash$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `postFeV1LacEventsInconsistenciesUnresolved()` */
  static readonly PostFeV1LacEventsInconsistenciesUnresolvedPath = '/v1/lac-events/inconsistencies/unresolved';

  /**
   * Search unresolved inconsistencies with optional filters.
   * Unresolved = status Open or Closing.
   *
   * Search unresolved inconsistencies with optional filters.
   * Unresolved = status Open or Closing.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postFeV1LacEventsInconsistenciesUnresolved$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postFeV1LacEventsInconsistenciesUnresolved$Plain$Response(params?: PostFeV1LacEventsInconsistenciesUnresolved$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<InconsistenciesUnresolvedPaginatedResponse>> {
    return postFeV1LacEventsInconsistenciesUnresolved$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Search unresolved inconsistencies with optional filters.
   * Unresolved = status Open or Closing.
   *
   * Search unresolved inconsistencies with optional filters.
   * Unresolved = status Open or Closing.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postFeV1LacEventsInconsistenciesUnresolved$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postFeV1LacEventsInconsistenciesUnresolved$Plain(params?: PostFeV1LacEventsInconsistenciesUnresolved$Plain$Params, context?: HttpContext): Observable<InconsistenciesUnresolvedPaginatedResponse> {
    return this.postFeV1LacEventsInconsistenciesUnresolved$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<InconsistenciesUnresolvedPaginatedResponse>): InconsistenciesUnresolvedPaginatedResponse => r.body)
    );
  }

  /**
   * Search unresolved inconsistencies with optional filters.
   * Unresolved = status Open or Closing.
   *
   * Search unresolved inconsistencies with optional filters.
   * Unresolved = status Open or Closing.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postFeV1LacEventsInconsistenciesUnresolved$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postFeV1LacEventsInconsistenciesUnresolved$Json$Response(params?: PostFeV1LacEventsInconsistenciesUnresolved$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<InconsistenciesUnresolvedPaginatedResponse>> {
    return postFeV1LacEventsInconsistenciesUnresolved$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Search unresolved inconsistencies with optional filters.
   * Unresolved = status Open or Closing.
   *
   * Search unresolved inconsistencies with optional filters.
   * Unresolved = status Open or Closing.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postFeV1LacEventsInconsistenciesUnresolved$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postFeV1LacEventsInconsistenciesUnresolved$Json(params?: PostFeV1LacEventsInconsistenciesUnresolved$Json$Params, context?: HttpContext): Observable<InconsistenciesUnresolvedPaginatedResponse> {
    return this.postFeV1LacEventsInconsistenciesUnresolved$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<InconsistenciesUnresolvedPaginatedResponse>): InconsistenciesUnresolvedPaginatedResponse => r.body)
    );
  }

  /** Path part for operation `postFeV1LacEventsInconsistenciesResolved()` */
  static readonly PostFeV1LacEventsInconsistenciesResolvedPath = '/v1/lac-events/inconsistencies/resolved';

  /**
   * Search resolved inconsistencies with optional filters.
   * Resolved = status Closed.
   *
   * Search resolved inconsistencies with optional filters.
   * Resolved = status Closed.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postFeV1LacEventsInconsistenciesResolved$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postFeV1LacEventsInconsistenciesResolved$Plain$Response(params?: PostFeV1LacEventsInconsistenciesResolved$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<InconsistenciesResolvedPaginatedResponse>> {
    return postFeV1LacEventsInconsistenciesResolved$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Search resolved inconsistencies with optional filters.
   * Resolved = status Closed.
   *
   * Search resolved inconsistencies with optional filters.
   * Resolved = status Closed.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postFeV1LacEventsInconsistenciesResolved$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postFeV1LacEventsInconsistenciesResolved$Plain(params?: PostFeV1LacEventsInconsistenciesResolved$Plain$Params, context?: HttpContext): Observable<InconsistenciesResolvedPaginatedResponse> {
    return this.postFeV1LacEventsInconsistenciesResolved$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<InconsistenciesResolvedPaginatedResponse>): InconsistenciesResolvedPaginatedResponse => r.body)
    );
  }

  /**
   * Search resolved inconsistencies with optional filters.
   * Resolved = status Closed.
   *
   * Search resolved inconsistencies with optional filters.
   * Resolved = status Closed.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postFeV1LacEventsInconsistenciesResolved$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postFeV1LacEventsInconsistenciesResolved$Json$Response(params?: PostFeV1LacEventsInconsistenciesResolved$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<InconsistenciesResolvedPaginatedResponse>> {
    return postFeV1LacEventsInconsistenciesResolved$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Search resolved inconsistencies with optional filters.
   * Resolved = status Closed.
   *
   * Search resolved inconsistencies with optional filters.
   * Resolved = status Closed.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postFeV1LacEventsInconsistenciesResolved$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postFeV1LacEventsInconsistenciesResolved$Json(params?: PostFeV1LacEventsInconsistenciesResolved$Json$Params, context?: HttpContext): Observable<InconsistenciesResolvedPaginatedResponse> {
    return this.postFeV1LacEventsInconsistenciesResolved$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<InconsistenciesResolvedPaginatedResponse>): InconsistenciesResolvedPaginatedResponse => r.body)
    );
  }

  /** Path part for operation `postFeV1LacEventsInconsistenciesUnresolvedExport()` */
  static readonly PostFeV1LacEventsInconsistenciesUnresolvedExportPath = '/v1/lac-events/inconsistencies/unresolved/export';

  /**
   * Export unresolved inconsistencies to Excel with applied filters.
   *
   * Export unresolved inconsistencies to Excel with applied filters.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postFeV1LacEventsInconsistenciesUnresolvedExport$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postFeV1LacEventsInconsistenciesUnresolvedExport$Plain$Response(params?: PostFeV1LacEventsInconsistenciesUnresolvedExport$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return postFeV1LacEventsInconsistenciesUnresolvedExport$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Export unresolved inconsistencies to Excel with applied filters.
   *
   * Export unresolved inconsistencies to Excel with applied filters.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postFeV1LacEventsInconsistenciesUnresolvedExport$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postFeV1LacEventsInconsistenciesUnresolvedExport$Plain(params?: PostFeV1LacEventsInconsistenciesUnresolvedExport$Plain$Params, context?: HttpContext): Observable<Blob> {
    return this.postFeV1LacEventsInconsistenciesUnresolvedExport$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /**
   * Export unresolved inconsistencies to Excel with applied filters.
   *
   * Export unresolved inconsistencies to Excel with applied filters.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postFeV1LacEventsInconsistenciesUnresolvedExport$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postFeV1LacEventsInconsistenciesUnresolvedExport$Json$Response(params?: PostFeV1LacEventsInconsistenciesUnresolvedExport$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return postFeV1LacEventsInconsistenciesUnresolvedExport$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Export unresolved inconsistencies to Excel with applied filters.
   *
   * Export unresolved inconsistencies to Excel with applied filters.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postFeV1LacEventsInconsistenciesUnresolvedExport$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postFeV1LacEventsInconsistenciesUnresolvedExport$Json(params?: PostFeV1LacEventsInconsistenciesUnresolvedExport$Json$Params, context?: HttpContext): Observable<Blob> {
    return this.postFeV1LacEventsInconsistenciesUnresolvedExport$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `postFeV1LacEventsInconsistenciesResolvedExport()` */
  static readonly PostFeV1LacEventsInconsistenciesResolvedExportPath = '/v1/lac-events/inconsistencies/resolved/export';

  /**
   * Export resolved inconsistencies to Excel with applied filters.
   *
   * Export resolved inconsistencies to Excel with applied filters.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postFeV1LacEventsInconsistenciesResolvedExport$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postFeV1LacEventsInconsistenciesResolvedExport$Plain$Response(params?: PostFeV1LacEventsInconsistenciesResolvedExport$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return postFeV1LacEventsInconsistenciesResolvedExport$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Export resolved inconsistencies to Excel with applied filters.
   *
   * Export resolved inconsistencies to Excel with applied filters.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postFeV1LacEventsInconsistenciesResolvedExport$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postFeV1LacEventsInconsistenciesResolvedExport$Plain(params?: PostFeV1LacEventsInconsistenciesResolvedExport$Plain$Params, context?: HttpContext): Observable<Blob> {
    return this.postFeV1LacEventsInconsistenciesResolvedExport$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /**
   * Export resolved inconsistencies to Excel with applied filters.
   *
   * Export resolved inconsistencies to Excel with applied filters.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postFeV1LacEventsInconsistenciesResolvedExport$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postFeV1LacEventsInconsistenciesResolvedExport$Json$Response(params?: PostFeV1LacEventsInconsistenciesResolvedExport$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return postFeV1LacEventsInconsistenciesResolvedExport$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Export resolved inconsistencies to Excel with applied filters.
   *
   * Export resolved inconsistencies to Excel with applied filters.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postFeV1LacEventsInconsistenciesResolvedExport$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postFeV1LacEventsInconsistenciesResolvedExport$Json(params?: PostFeV1LacEventsInconsistenciesResolvedExport$Json$Params, context?: HttpContext): Observable<Blob> {
    return this.postFeV1LacEventsInconsistenciesResolvedExport$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

}
